<section class="route">
  <p class="f-body-2xs f-muted">
    {{ 'labels.route' | translate | uppercase }}
  </p>

  <div class="container">
    <div class="bar-container">
      <div
        class="bar"
        [style.height]="`calc(100% - ${lastPointItemHeight()}px)`"
      ></div>
    </div>

    <div class="wrapper">
      @for (point of orderPoints(); track point.uuid) {
        <div class="item" #routeItem>
          <div class="details-container">
            @let isLoading = point.category === OrderPointCategory.LOADING;
            @let isUnloading = point.category === OrderPointCategory.UNLOADING;
            <div class="heading">
              <p class="f-body-s f-medium">
                {{
                  `${DictionaryCode.ORDER_POINT_TYPE}.${point.type}` | translate
                }}
              </p>

              @if (
                (isLoading || isUnloading) && point.referenceNumber;
                as referenceNumber
              ) {
                <span class="f-muted f-body-xs">
                  {{ 'labels.pointReferenceNumber' | translate }}
                  {{ referenceNumber }}
                </span>
              }
            </div>

            <div class="details f-body-xs">
              @let isTransit = point.category === OrderPointCategory.TRANSIT;
              @let isCheckpointBase =
                point.category === OrderPointCategory.CHECKPOINT ||
                point.category === OrderPointCategory.PICKUP;
              @if (isTransit || isCheckpointBase) {
                {{ point.name }}
              }

              <onyx-address
                [address]="isTransit ? point.startAddress : point.address"
                [endAddress]="isTransit ? point.endAddress : null"
                [format]="isTransit ? 'transit' : 'pdf'"
              ></onyx-address>

              @if (isLoading || isUnloading) {
                <div class="goods">
                  @for (
                    good of pointsGoods().get(point.uuid);
                    track good.uuid
                  ) {
                    <span class="f-muted">
                      {{
                        good.type
                          ? (good.type.names | onyxLanguage)
                          : good.typeName
                      }}

                      {{ good.unit.names | onyxLanguage }}

                      @if (good.size) {
                        ·
                        {{ good | goodQuantity }}
                      } @else {
                        {{ good.totalWeight | number }} kg
                      }

                      @if (good.referenceNumber) {
                        ·
                        {{ 'labels.goodReferenceNumber' | translate }}
                        {{ good.referenceNumber }}
                      }
                    </span>
                  }
                </div>
              }

              @if (isCheckpointBase && point.phone; as phone) {
                <p class="f-muted">{{ phone | onyxPhone }}</p>
              }

              <p class="f-muted">{{ point.driverNote }}</p>
            </div>
          </div>

          <div class="time-windows f-muted f-body-xs">
            @if (getTimeWindows(point); as pointTimeWindows) {
              @let timeWindows = pointTimeWindows.value;

              @for (timeWindow of timeWindows; track timeWindow) {
                <p>{{ timeWindow }}</p>
              }
            }
          </div>
        </div>
      }
    </div>
  </div>
</section>
